/**
 * formatApiError — coerce whatever an RTK Query / axios / fetch error
 * actually contains into a single human-readable string.
 *
 * RTK Query's fetchBaseQuery sticks the response body in `err.data`. The
 * data manager and wcibapi mostly send `text/plain` strings, but a few
 * routes (e.g. createMQTTSetup's 409, and any future JSON 4xx) return
 * `application/json` — at which point `err.data` is an object with a
 * `message` field. Pre-this-helper, three dialogs each rolled their own
 * `JSON.stringify(msg)` fallback that rendered `{"message":"...","status":...}`
 * verbatim at the user.
 *
 * Order of precedence:
 *   1. err.data, if string → use it
 *   2. err.data.message, if string → use it
 *   3. err.error (RTK Query "FETCH_ERROR" string for network failures)
 *   4. err.message (plain Error)
 *   5. JSON.stringify(err.data) as a last resort (object body, no .message)
 *   6. fallback
 */
export function formatApiError(err, fallback = 'Request failed') {
    if (err === null || err === undefined) return fallback;

    const { data } = err;
    if (typeof data === 'string' && data.length > 0) return data;
    if (data && typeof data === 'object') {
        if (typeof data.message === 'string' && data.message.length > 0) return data.message;
        if (typeof data.error === 'string' && data.error.length > 0) return data.error;
    }

    if (typeof err.error === 'string' && err.error.length > 0) return err.error;
    if (typeof err.message === 'string' && err.message.length > 0) return err.message;

    if (data && typeof data === 'object') {
        try {
            return JSON.stringify(data);
        } catch (_serialiseErr) {
            // circular ref or similar — fall through
        }
    }

    return fallback;
}
